import FormRow from 'Components/FormRow';
import InputHandler from 'Components/InputHandler';
import PlatformConditional from 'Components/PlatformConditional';
import { FormattedMessage } from 'react-intl';
import * as React from 'react';

const ENMGForm = ({ formData }: IOwnProps): React.JSX.Element => (
  <React.Fragment>
    <FormRow title="general.date">
      <InputHandler
        type="PartialDate"
        editing={true}
        name="date"
        formData={formData}
        dateDefault="now"
        isNotCancellable={true}
      />
    </FormRow>
    <PlatformConditional platform={['polyneuro']}>
      <FormRow title="clinicalstudy.polyneuro.clinicalSubtypeClassification">
        <InputHandler
          type="Radio"
          editing={true}
          name="clinicalSubtypeClassification"
          formData={formData}
          options={['motor', 'sensory', 'sensorimotor']}
          optionFormatter={o => <FormattedMessage id={'clinicalstudy.polyneuro.opts.' + o} />}
        />
      </FormRow>
      <FormRow title="clinicalstudy.polyneuro.pathophysiologicalClassification">
        <InputHandler
          type="Radio"
          editing={true}
          name="pathophysiologicalClassification"
          formData={formData}
          options={['demyelinating', 'axonal', 'mixed', 'normal', 'unknown']}
          optionFormatter={o => <FormattedMessage id={'clinicalstudy.polyneuro.opts.' + o} />}
        />
      </FormRow>
      <FormRow title="clinicalstudy.polyneuro.conductionBlockOutsideTypicalEntrapmentSites">
        <InputHandler
          type="Radio"
          editing={true}
          name="conductionBlockOutsideTypicalEntrapmentSites"
          formData={formData}
          options={['yes', 'no', 'unknown']}
          optionFormatter={o => <FormattedMessage id={'general.' + o} />}
        />
      </FormRow>
    </PlatformConditional>
  </React.Fragment>
);

interface IOwnProps {
  formData: IFormData<IDocumentWithTypeV2<'enmg'>>;
}

export default ENMGForm;
